document.querySelectorAll(".shopify-section").forEach((item, index) => {
  item.dataset.shopifySectionIndex = index + 1;
});

class TabLinksPanel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const targetSection = document.querySelector(
      `[data-shopify-section-index="${this.targetSection}"]`
    );

    if (!targetSection) return;

    this.append(targetSection);
  }

  disconnectedCallback() {}

  get targetSection() {
    return this.getAttribute("target-section");
  }
}

if (!customElements.get("tab-links-panel")) {
  customElements.define("tab-links-panel", TabLinksPanel);
}
